import { TextureData } from "../../../types/types";
import { RectSize } from "../../../utils/RectSize";
import { AppSettings } from "../../managers/AppSettings";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { ResultsListItem } from "./ResultsListItem";
import { ResultsHeaderItem } from "./ResultsHeaderItem";
import { ScrollPaneTitledListContent } from "./ScrollPaneTitledListContent";
import { AppLocalization } from "../../localization/AppLocalization";
import { ThemeDataManager } from "../../managers/ThemeDataManager";
import { LayoutDataManager } from "../../managers/LayoutDataManager";
import { AppObjectPool } from "../../pooling/AppObjectPool";
import { AppFontsConfig } from "../../data/AppConstants";
import { GameCompleteView, GameCompleteViewLayout } from "./GameCompleteView";
import { SettingsItem } from "../options/SettingsItem";

/**
 * title
 * NEW: GAME_OVER content (if applicable-changes size and positions of following items)
 * list of category items
 * 
 * Exec order:
    Init
    Build
    SetData
    SetWidth
 */
export class DealCompleteResultsContent
    extends ScrollPaneTitledListContent {
    public gameComplete: GameCompleteView;

    protected poolGroupKey: string = "ResultsListItem";

    private itemBgTextureData: TextureData;
    private itemLabelTextStyle: Phaser.Types.GameObjects.Text.TextStyle;
    private delimiterLineAlpha: number;


    public override Init(): void {
        // > items
        super.Init();

        this.delimiterLineAlpha = LayoutDataManager.GetSharedData().general.screen.item.delimiterLine.alpha;

        // theme needed for base
        this.nodeLoc = AppLocalization.GetVariationData().dealComplete.results;
        this.nodeTheme = ThemeDataManager.GetVariationData().dealComplete.results;
    }

    public override Build(): void {
        // > build title
        super.Build();
        this.add(this.nsContentBg);

        // refs
        const headerStyle = {
            color: AppSettings.colors.yellowString,
            align: "left",
            // fontSize: "36px",
            // fontFamily: AppSettings.fontFamilies.MontserratBold,
            // metrics: AppSettings.metrics.montserratBold36,
            fontFamily: AppFontsConfig.DealCompleteHeaderItemLabel.fontFamily,
            fontSize: AppFontsConfig.DealCompleteHeaderItemLabel.fontSize,
            metrics: AppFontsConfig.DealCompleteHeaderItemLabel.metrics,
        };
        this.itemLabelTextStyle = {
            color: AppSettings.colors.whiteString,
            align: "left",
            // fontSize: "36px",
            // fontFamily: AppSettings.fontFamilies.MontserratBold,
            // metrics: AppSettings.metrics.montserratBold36,
            fontFamily: AppFontsConfig.DealCompleteListItemLabel.fontFamily,
            fontSize: AppFontsConfig.DealCompleteListItemLabel.fontSize,
            metrics: AppFontsConfig.DealCompleteListItemLabel.metrics,
        };

        const headerTextureData = {
            texture: LoaderFileKeys.ui,
            frame: "rect-2x2-transparent.png"
        };
        this.itemBgTextureData = {
            texture: LoaderFileKeys.ui,
            frame: "rect-2x2-transparent.png"
        };

        // header
        // - top most table row
        const header: ResultsHeaderItem = new ResultsHeaderItem(this.scene);
        header.Init(
            headerTextureData,
            headerStyle,
            LayoutDataManager.GetSharedData().general.screen.header.delimiterLine.alpha,
        );
        header.Build();
        header.SetData(
            this.nodeLoc.cats[0].itemLabel,
            this.nodeLoc.cats[1].itemLabel,
            this.nodeLoc.cats[2].itemLabel
        );
        this.add(header);
        this.header = header;

        this.gameComplete = new GameCompleteView(this);

        // this.UpdateFromLocalizationChange();
    }

    public override UpdateFromLocalizationChange(): void {
        this.nodeLoc = AppLocalization.GetVariationData().dealComplete.results;
        // this.nodeTheme = ThemeDataManager.GetVariationData().dealComplete.results;

        // main content title
        const sTitle: string = this.nodeLoc.title.itemLabel;
        // content header list item
        (this.header as ResultsHeaderItem).SetData(
            this.nodeLoc.cats[0].itemLabel,
            this.nodeLoc.cats[1].itemLabel,
            this.nodeLoc.cats[2].itemLabel,
        );

        this.btnTitle.SetLabel(sTitle);
    }

    public SetData(inputData: any): void {
        // console.log("SetData")
        // gameCompleteType
        this.gameComplete.SetLayout(inputData.gameCompleteViewLayout as GameCompleteViewLayout);

        // result list items
        let item: ResultsListItem;
        if (this.items.length > inputData.items.length) {
            // pool excess items from screen to pool
            let numPoolItems = this.items.length - inputData.items.length;
            while (numPoolItems--) {
                item = this.items.pop() as any as ResultsListItem;
                // remove item from live data model/view
                this.remove(item);
                AppObjectPool.DropObject(item, this.poolGroupKey);
            }
        }
        else
            // if got not enough items on screen (need to display more (new data))
            if (this.items.length < inputData.items.length) {
                // create (or take from pool) additional items to put on screen
                let numCreateItems = inputData.items.length - this.items.length;
                while (numCreateItems--) {
                    // got item in pool
                    if (AppObjectPool.GetObjectsCount(this.poolGroupKey) > 0) {
                        item = AppObjectPool.PickObject(this.poolGroupKey);
                    }
                    // no more items in pool
                    else {
                        // create new, initialize, build
                        item = new ResultsListItem(this.scene);
                        item.Init(this.itemBgTextureData, this.itemLabelTextStyle, this.delimiterLineAlpha);
                        item.Build();
                    }
                    // move item to live data model/view
                    this.items.push(item as any);
                    this.add(item);
                }
            }

        // this.items.forEach((item:ResultsListItem, i)=>{
        this.items.forEach((item: any, i) => {
            // console.log(inputData.items[i]);
            (item as ResultsListItem).SetData(
                inputData.items[i].label1,
                inputData.items[i].label2,
                inputData.items[i].label3,
                this.items.length != i + 1
            );
        });

        this.sendToBack(this.nsContentBg);
    }

    public override SetWidth(width: number): void {
        // console.log("SetWidth");

        // position and calculate size for all base items
        this.size.Set(width, 0);

        // basedon layout here, calculate height (size)
        this.gameComplete.SetWidth(width);
        this.gameComplete.SetHeightByLayout(); // uses layout set prior (@see specif. tableMachine's SetLayout)
        this.size.height += this.gameComplete.GetSize().height;

        // btnTitle
        // - title above table
        const titleHeight = Math.max(this.btnTitle.label.displayHeight, this.btnTitle.icon.displayHeight) * this.btnTitle.scale;
        this.titleHeightInclPadding = this.titlePadding.top + titleHeight + this.titlePadding.bottom;

        // btnTitle
        this.btnTitle.setPosition(30, this.size.height + this.titlePadding.top + titleHeight / 2);
        this.size.height += this.titleHeightInclPadding;

        // header
        // NOTE: some contents dont have header @see DealCompleteHandsContent
        if (this.header != undefined) {
            this.header.SetSize(width, this.header.SetWidthGetHeight(width));
            this.header.y = this.size.height;
            this.size.height += this.header.GetSize().height;
        }

        // items
        this.items.forEach((item: SettingsItem) => {
            item.SetSize(width, item.SetWidthGetHeight(width));
        });

        // reposition
        // const startDropItemsY = this.header.GetSize().height;
        // this.size.SetSize(width, startDropItemsY);
        this.items.forEach((item: SettingsItem, i) => {
            item.y = this.size.height;
            const itemSize: RectSize = item.GetSize();
            this.size.height += itemSize.height;
            // console.log(i, itemSize.height)
        });

        this.RedrawBorder();
    }

    protected override RedrawBorder(): void {
        const gameCompleteSize = this.gameComplete.GetSize();
        this.nsContentBg.setPosition(
            -this.nsBorderInnerPadding,
            gameCompleteSize.height + this.titleHeightInclPadding - this.nsBorderInnerPadding,
        )
        this.nsContentBg.setSize(
            this.size.width + this.nsBorderInnerPadding * 2,
            this.size.height + this.nsBorderInnerPadding * 2 - this.titleHeightInclPadding - gameCompleteSize.height
        );
    }

    public override GetSize(): RectSize {
        return this.size;
    }
}